export const Colors = {
  primary: "rgba(0, 145, 255, 1)",
  primaryNeutral: "rgba(0, 145, 255, 0.5)",
  primaryLightest: "rgba(0, 145, 255, 0.05)",
  primaryLighter: "rgba(0, 145, 255, 0.1)",
  secondary: "rgba(0, 145, 255, 0.2)",

  textPrimary: "rgba(0, 0, 0, 0.5)",
  textPlaceholder: "rgba(0, 0, 0, 0.2)",
  textLight: "rgba(0, 0, 0, 0.2)",

  shadow: {
    primary: "rgba(37, 6, 64, 0.1)",
  },

  statusDisabled: "#e6e6e6",
  statusReady: "#ffc766",
  statusEnabled: "#33b4ff",
  statusError: "#ff0000",
};
